import { atom } from 'jotai';

export type AuthStatus = 'unauthenticated' | 'loading' | 'authenticated';

const authAtom = atom<AuthStatus>('loading');

export { authAtom };
